import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useStoreSelector } from 'v3/data/store';
import { setStoreIdsListFilter } from 'v3/data/store/contracting/actions';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
import { theme } from 'v3/styles/global-styles';
import { FlexButton } from '../../Button/FlexButton';
import { InputFormController } from '../../Inputs/InputFormController';
import { Stores } from './Store';
import {
  AlignFilter,
  CloseIconStyled,
  Container,
  Content,
  DividerStyled,
  Footer,
  Header,
  StyledDialog,
} from './styles';
import { IStoreFilterProps } from './types';

export const StoreFilter = ({ open, setOpenModal }: IStoreFilterProps) => {
  const { control } = useForm<any>({ mode: 'onChange' });
  const [searchValue, setSearchValue] = useState<string>('');
  const { storeList } = useStoreSelector((store) => store.store);
  const { isMobile } = useBreakpoints();
  const selectedStoreIds = storeList.filter((store) => store.checked).map((store) => store.id);

  const handleInputChange = (value: string) => {
    setSearchValue(value);
  };

  const handleFilter = () => {
    setOpenModal(false);
    setStoreIdsListFilter(selectedStoreIds);
  };

  return (
    <StyledDialog open={open} fullScreen={isMobile}>
      <Container>
        <Header>
          <CloseIconStyled onClick={() => setOpenModal(false)} aria-label="Fechar modal" />
          <HeadlineMedium color={theme.palette.common.white}>Lista de lojas</HeadlineMedium>

          <AlignFilter>
            <InputFormController
              data-testid="input-searchValue"
              formControl={control}
              formControlName="searchValue"
              placeholder="Procurar por nome ou cnpj da loja"
              fullWidth
              onChangeInput={handleInputChange}
              startAdornmentIcon={SearchIcon}
            />
          </AlignFilter>
        </Header>
        <Content>
          <Stores searchValue={searchValue} />
        </Content>
        <DividerStyled />
        <Footer>
          <FlexButton text="Filtrar lojas selecionadas" size="small" handleClick={handleFilter} />
        </Footer>
      </Container>
    </StyledDialog>
  );
};
